import React from "react";

export default function SummaryCard({ summary }) {
  if (!summary) return null;

  const {
    period_start,
    period_finish,
    actual_total,
    plan_total,
    achievement_rate,
  } = summary;

  const actual = Math.round(Number(actual_total) || 0);
  const plan = Math.round(Number(plan_total) || 0);

  return (
    <div className="bg-white border rounded-xl shadow-sm p-5 w-full lg:w-[360px] space-y-4">
      {/* ▶ 타이틀 */}
      <div className="text-base font-semibold text-slate-800">
        공정 요약
      </div>

      {/* ▶ 기간 */}
      <div className="flex justify-between text-sm">
        <span className="text-gray-500">기간</span>
        <span className="font-medium text-gray-800">
          {period_start} ~ {period_finish}
        </span>
      </div>

      {/* ▶ 실적 / 계획 */}
      <div className="flex justify-between text-sm">
        <span className="text-gray-500">실적 / 계획</span>
        <span className="font-medium text-gray-800">
          {actual.toLocaleString()} / {plan.toLocaleString()}
        </span>
      </div>

      {/* ▶ 달성률 */}
      <div className="space-y-2">
        <div className="flex justify-between text-sm">
          <span className="text-gray-500">달성률</span>
          <span className="font-semibold text-blue-600">
            {achievement_rate}%
          </span>
        </div>

        <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
          <div
            className="h-2 bg-blue-500 rounded-full"
            style={{ width: `${achievement_rate}%` }}
          />
        </div>
      </div>
    </div>
  );
}
